/**
 * `GET` / `PATCH /admin/tradesman-switch` (SuperAdmin only, nhrapp#4397, D42-f): the per-company switch that
 * shows or hides the crew-facing Tradesman surfaces. No setting row on the server reads as `crewEnabled: false`.
 */
export interface TradesmanSwitch {
  companyId: string
  crewEnabled: boolean
}

/** A body without a string `companyId` and a boolean `crewEnabled` is unreadable: `null`, drawn as a failed load. */
export const normalizeTradesmanSwitch = (res: unknown): TradesmanSwitch | null => {
  if (!res || typeof res !== 'object') return null
  const { companyId, crewEnabled } = res as Record<string, unknown>
  if (typeof companyId !== 'string' || typeof crewEnabled !== 'boolean') return null
  return { companyId, crewEnabled }
}
